<template>
  <div v-if="chatboxMessages.length == 0" id="noMessageDisplay">
    Er zijn geen berichten van de luisteraars
  </div>
  <div v-else id="messageDisplay">
    <SingleChatAdmin v-for="chat in chatboxMessages" :chat="chat" :key="chat" />
  </div>
</template>

<script>
import $ from "jquery";
import "firebase/firestore";
import "firebase/firebase-storage";
import db from "@/firebase/firebaseInit";
import SingleChatAdmin from "@/components/SingularObjects/SingleChatAdmin.vue";
export default {
  data() {
    return {
      chatboxMessages: [],
    };
  },
  created() {
    this.realtimeListener();
  },
  components: {
    SingleChatAdmin,
  },
  methods: {
    realtimeListener() {
      db.firestore()
        .collection("messages")
        .orderBy("month", "desc")
        .orderBy("day", "desc")
        .orderBy("time")
        .onSnapshot((snapshot) => {
          $("#messageDisplay div").remove();
          this.chatboxMessages = [];
          snapshot.forEach((doc) => {
            this.chatboxMessages.push({
              uid: doc.data().uid,
              phoneNumber: doc.data().phoneNumber,
              user: doc.data().user,
              message: doc.data().message,
              time: doc.data().time,
              day: doc.data().day,
              month: doc.data().month,
              year: new Date().getFullYear(),
              fileMessage: doc.data().fileMessage,
              fromAdmin: doc.data().fromAdmin,
              isFile: doc.data().isFile,
            });
          });
          console.log(this.chatboxMessages);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#messageDisplay {
  margin-top: 100px;
}
#noMessageDisplay {
  margin-top: 100px;
  font-family: "Lato";
}
</style>